import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export type PlaybookDimension = { name: string, value: string }

export enum PlaybookStatus {
    ACTIVE = 'ACTIVE',
    DRAFT = 'DRAFT',
    DEPRECATED = 'DEPRECATED',
}

export type Playbook = {
    id: string,
    name?: string,
    displayName?: string,
    description?: string,
    stateMachineArn?: string,
    inputSchema?: string,
    category?: string,
    status?: PlaybookStatus,
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export interface IPlaybookTableColumn extends ITableColumn {
    render?: (item: Playbook) => ReactNode;
}

export type PlaybookRecordFormProps = {
    record: Playbook,
    handleSubmit: (values: Playbook) => void
    handleCancel: () => void
}


export type ListPlaybooks = {
    listPlaybooks: { items: Playbook[] }
}

export type GetPlaybook = {
    getPlaybook: Playbook
}

export type CreatePlaybook = {
    createPlaybook: Playbook
}

export type UpdatePlaybook = {
    updatePlaybook: Playbook
}

export type DeletePlaybook = {
    deletePlaybook: string
}
